import { interopDefault } from '~/router/utils'
import { playgroundToolsRoutes } from '~/router/routes/car/playground/tools'
import { playgroundDirectivesRoutes } from '~/router/routes/car/playground/directives'
import { playgroundCompositionsRoutes } from '~/router/routes/car/playground/compositions'
import { playgroundComponentsRoutes } from '~/router/routes/car/playground/components'
import { addRouteMeta } from '~/utils/router'

export default [
  {
    name: '__playground',
    path: '/playground',
    component: () => interopDefault(import('~/pages/playground/index.vue')),
    children: [
      ...playgroundToolsRoutes,
      ...playgroundDirectivesRoutes,
      ...playgroundCompositionsRoutes,
      ...playgroundComponentsRoutes
    ].map(r => addRouteMeta(r, { noFooter: true })),
    meta: {
      noFooter: true
    }
  }
]
